import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityListManageRouteTypeEnums } from '../Type/PackEntityListManageRouteTypeEnums'

interface DataModel {
	aid?: string
}

/**
 *	抄送配置查询
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] aid
 */

export function msgCopyconfigquery(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityListManageRouteTypeEnums>
export function msgCopyconfigquery(
	data: DataModel,
	options?: IRequestOptions,
): Promise<
	PackEntityListManageRouteTypeEnums extends { msg: unknown } ? PackEntityListManageRouteTypeEnums['msg'] : undefined
>
export function msgCopyconfigquery(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid } = data
	return net('/frontApi/app/msgCopy/config/query', {
		method: 'post',
		params: {
			aid,
		},

		...(options || {}),
	})
}
